import { Component, Input, ViewChild, OnInit, OnDestroy, NgZone } from '@angular/core';

import { Subscription } from 'rxjs';

import { ModalDirective } from 'ngx-bootstrap/modal';

import { Document, DocumentService } from './../../../../shared/index';
import { DocumentListComponent } from './../../../index';

@Component({
    selector: 'document-history',
    templateUrl: './document-history.html',
    standalone: false
})

export class DocumentHistoryComponent {
    @ViewChild('documentHistoryModal') documentHistoryModal: ModalDirective;

    public document: Document = new Document();
    public historyDocuments: Document[] = [];

    private viewHistorySubscription: Subscription;
    private documentSubscription: Subscription;

    constructor(
        private _documentService: DocumentService,
        private _documentListComponent: DocumentListComponent,
        private _ngZone: NgZone
    ) {
    }

    public close(): void {
        this.documentHistoryModal.hide();
    }

    ngOnInit(): void {
        this.documentSubscription = this._documentService.historyDocumentsChange.subscribe((documents: Document[]) => {
            this.historyDocuments = documents;
        });

        this.viewHistorySubscription = this._documentListComponent.viewHistory.subscribe((document: Document) => {
            this.document = document;
            this._documentService.getHistory(this.document.MetadataId);
            this.documentHistoryModal.show();
        });
    }

    ngOnDestroy(): void {
        this.viewHistorySubscription.unsubscribe();
        this.documentSubscription.unsubscribe();
    }
}
